// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__yOiLQ","search":"Settings_search__2v9N-","filter":"Settings_filter__3XuRQ"};